import React from 'react';
import '../css/AboutHero.css';

const AboutHero = () => {
  const metricCards = [
    { id: 1, value: "10,000+", label: "STUDENTS TRAINED" },
    { id: 2, value: "16+ Years", label: "TRAINING EXPERIENCE" },
    { id: 3, value: "India & Gulf", label: "PLACEMENT SUPPORT" },
    { id: 4, value: "Practical", label: "INDUSTRY ORIENTED" }
  ];

  return (
    <section className="gfi-about-hero-section">
      {/* Industrial Dark Blue Semi-Transparent Overlay */}
      <div className="gfi-about-hero-overlay"></div>
      
      <div className="gfi-about-hero-container">
        
        {/* BREADCRUMB ROW LINKS */}
        <div className="gfi-about-breadcrumb">
          <span className="gfi-bc-home">HOME</span> 
          <span className="gfi-bc-separator">&gt;</span> 
          <span className="gfi-bc-current">ABOUT GREENFIELD ACADEMY</span>
        </div>

        {/* MAIN DISPLAY HEADINGS GROUP */}
        <div className="gfi-about-hero-content-frame">
          <h1 className="gfi-about-main-title">
            ABOUT <br className="gfi-mobile-break" />
            <span className="gfi-brand-highlight">GREENFIELD INDUSTRIAL FIRE AND SAFETY ACADEMY</span>
          </h1>
          
          <div className="gfi-about-tagline-bar">
            <span className="gfi-vertical-accent-line"></span>
            <p className="gfi-about-tagline-text">
              Fire & Safety, Industrial Safety & NEBOSH Training Institute in Bihar, UP & India
            </p>
          </div>
        </div>

        {/* 4-COLUMN FLOATING METRICS COUNTER CARD TRAILER */}
        <div className="gfi-about-metrics-grid">
          {metricCards.map((card) => (
            <div key={card.id} className="gfi-metric-glass-card">
              <h3 className="gfi-metric-value-num">{card.value}</h3>
              <p className="gfi-metric-label-txt">{card.label}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AboutHero;